<template>
  <div class="layout-popup-wrapper" @touchmove.prevent>
    <w-popup-show :state="state">
      <div slot="content" class="flex-column layout-container">
        <div class="top-operate flex-start">
          <span :class="{'active': activeIndex === 0}" class="flex-column-center" @click="changeIndex(0)">基本信息</span>
          <span :class="{'active': activeIndex === 1}" class="flex-column-center" @click="changeIndex(1)">布局</span>
          <span :class="{'active': activeIndex === 2}" class="flex-column-center" @click="changeIndex(2)">顶部</span>
          <span :class="{'active': activeIndex === 3}" class="flex-column-center" @click="changeIndex(3)">标题样式</span>
        </div>
        <div class="style">
          <div v-for="(item, index) in recommendTemplate.layout[activeIndex].pickerData" :key="index" class="flex-column-center style-item"
               :class="{'style-item-active': layoutOperateActive(item)}"
               @click="changeLayout(item, index)">
            <p class="icon-wrapper flex-center">
              <img v-if="!!item.isVip" class="vipimg" :src="layoutOperateActive(item) ? 'https://files.wondercv.com/PC/editor/VIPtag.png' : 'https://files.wondercv.com/APP/editor/APP_VIP.png'" alt="">
              <span class="iconfont" :class="item.icon"></span>
            </p>
            <span class="style-title">{{ item.label }}</span>
          </div>
        </div>
        <div class="options-wrapper" v-show="activeIndex == 2 && format_info.top_format == 'line'">
          <cube-scroll ref="scroll" direction="horizontal" class="horizontal-scroll-list-wrap">
            <ul class="list-wrapper options-container color-wrapper">
              <template v-for="(val, index) in recommendTemplate.layout[activeIndex].colorArr">
                <li :key="index + 'cd'"
                    :style="{'background-color': val}" class="theme-color list-item"
                    :class="{'theme-color-active': val === format_info.top_line_color}"
                    @click="changeLayout({type: 'top_line_color', value: val})"></li>
              </template>
            </ul>
          </cube-scroll>
        </div>
        <div class="style-footer flex-between">
          <button class="iconfont iconx" @click="handleClose"></button>
          <button class="iconfont iconcheck" @click="handleClick"></button>
        </div>
      </div>
    </w-popup-show>
    <template v-if="quiteState">
      <w-popup-show :state="quiteState" class="quite-wrapper">
        <div slot="content" class="quite-container">
          <div class="flex-center" @click="quiteChange">放弃修改</div>
          <div class="flex-center" @click="() => {this.quiteState = false}">取消</div>
        </div>
      </w-popup-show>
    </template>
    
  </div>
</template>

<script>
import WPopupShow from '../../components/global/w-popup-show'
import recommendTemplate from "../../assets/json/recommend-template-style"
import { mapState, mapActions } from 'vuex'
export default {
  name:'layout',
  components: {WPopupShow},
  props: {
    state: Boolean
  },
  data(){
   return {
     recommendTemplate,
     activeIndex: 0,
     quiteState: false,
     copyFormatData: null, // 还原样式使用
     copyShowattrname: ''
   }
  },
  created() {
    this.copyFormatData = JSON.parse(JSON.stringify(this.cv.format_info)) 
    this.copyShowattrname = this.profiles.show_attr_name
  },
  methods: {
    ...mapActions('cv', [ 'updateCvDetail', 'updateProfileData' ]),
    changeIndex(index) {
      this.activeIndex = index
    },
    // 放弃修改
    async quiteChange() {
      this.quiteState = false
      let {token} = this.$route.params
      // 基本信息 
      let profilePayload = {show_attr_name: this.copyShowattrname}
      this.updateProfileData({ token, payload: profilePayload })
       // 布局、顶部、标题样式 
      await this.updateCvDetail({ token, payload: {format_info: this.copyFormatData, operation_type: 'update_format_info'}})
      this.$emit('handleClose')
    },
    async changeLayout(item) {
      let {token} = this.$route.params
      let type = this.recommendTemplate.layout[this.activeIndex].type
      let profilePayload = {}
      // 基本信息 
      if(this.activeIndex == 0) {
        profilePayload[type] = item.value
        this.updateProfileData({ token, payload: profilePayload })
      }
      // 布局、顶部、标题样式 
      else {
        // 顶部颜色
        if(type == 'top_format' && item.type == 'top_line_color') {
          profilePayload.top_line_color = item.value
        } else {
          profilePayload[type] = item.value
        }  
        await this.updateCvDetail({ token, payload: {format_info: profilePayload, operation_type: 'update_format_info'}})
      }
    },
    handleClick() {
      this.$emit('handleClose')
    },
    handleClose() {
      // 拿之前的布局数据对比判断有没有变化
      let keyArr = ['head_format','top_format','title_format','title_color','top_line_color']
      let isNOChange = this.copyShowattrname ==  this.profiles.show_attr_name && keyArr.every(key => {
        return this.format_info[key] == this.copyFormatData[key]
      })
      if(isNOChange) {
        this.$emit('handleClose')
      } else {
        this.quiteState = true
      }     
    },
    layoutOperateActive(item) {
      if(recommendTemplate.layout[this.activeIndex].type == 'show_attr_name') {
        return this.profiles.show_attr_name == item.value
      } 
      return this.format_info[recommendTemplate.layout[this.activeIndex].type] === item.value
    }
  },
  computed:{
    ...mapState('cv', [ 'cv', 'profiles']),
    format_info() {
      return this.cv.format_info
    },

  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .layout-popup-wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    color: $color-light;
    .w-popup {
      @include ipx-content-bottom(54px);
    }
    .layout-container {
      @include ipx-content-bottom(54px);
      background: #181818;
      padding-top: 22px;
      width: 100vw;
      .top-operate {
        display: flex;
        justify-content: center;
        span {
          color: $color-dark-gray;
          line-height: 20px;
          margin-right: 29px;
          &:last-child {
            margin-right: 0;
          }
        }
        .active {
          font-size: $font-size-medium-x;
          line-height: 22px;
          color: $color-light;
          &:after {
            display: inline-block;
            content: '';
            width: 18px;
            height: 2px;
            border-radius: 1px;
            background-color: $color-theme;
            margin-top: 4px;
            margin-bottom: -4px;
            position: relative;
            z-index: 10;
          }
        }
      }
    }
    .style-footer {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 399;
      width: 100vw;
      background-color: #181818;
      color: $color-light;
      padding: 0 30px;
      @include ipx-footer(54px, 1px);
      .iconfont {
        font-size: 20px;
        font-weight: bold;
        color: $color-light;
      }
      button {
        background: none;
        border: none;
      }
      button:disabled {
        color: $color-dark-gray;
      }
    }
    .style {
      padding: 24px 24px 16px;
      background-color: #181818;
      width: 100vw;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .vipimg{
        width: 26px;
        height: 14px;
        position: absolute;
        top: -10px;
        right: -15px;
      }
      .style-item {
        .icon-wrapper {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #303030;
          margin-bottom: 8px;
          position: relative;
          .iconfont {
            font-weight: 500;
            color: #9C9C9C;
          }
        }
        .style-title {
          font-size: $font-size-small;
          white-space: nowrap;
          color: #9C9C9C;
        }
      }
      .style-item-active {
        .style-title {
          color: $color-light;
        }
        .icon-wrapper {
          border: 1px solid $color-light;
          .iconfont {
            color: $color-light;
          }
        }
      }
    }
    .options-wrapper {
      // padding: 16px 8px;
      background-color: #181818;
      width: 100vw;
      // height: 56px;
      .options-container {
        height: 24px;
      }
      .list-wrapper {
        min-width: 100vw;
        display: flex;
        gap: 22px;
        justify-content: center;
        .options-item {
          text-align: center;
          color: $color-dark-gray;
          padding-right: 32px;
          &:first-child {
            padding-left: 30px;
          }
          &:last-child {
            /*margin-right: 30px;*/
          }
        }
        .options-item-active {
          font-size: $font-size-medium-x;
          color: $color-light;
        }
        .theme-color {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          border: 4px solid #181818;
          box-sizing: content-box;
        }
        .theme-color-active {
          border-color: $color-light;
        }
      }
    }
    .quite-wrapper {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 401;
      transform: translateY(0);
      @include ipx-content-bottom(1px);
      /deep/ .mask {
        transform: translateY(-100%);
      }
      .quite-container {
        border-radius: 10px 10px 0 0;
        background-color: $color-light;
        width: 100vw;
        div {
          height: 64px;
          color: $color-title;
          font-size: $font-size-medium-x;
          &:first-child {
            color: $color-theme;
            border-bottom: 1px solid #F9F9F9;
          }
        }
      }
    }
  }
</style>
